
/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

/**
 * Global Components
 */

Vue.component('follow-organisation', require('./components/FollowOrganisation.vue').default);
Vue.component('reactions-like-dislike', require('./components/Reactions/ReactionsLikeDislike.vue').default);
Vue.component('ios-button', require('./components/IosButton.vue').default);
Vue.component('ul-select', require('./components/UlSelect.vue').default);
Vue.component('ul-rating', require('./components/UlRating.vue').default);

Vue.component('reply-contribution', require('./components/ReplyContributions/ReplyContributions.vue').default);
Vue.component('contribution-comment', require('./components/ReplyContributions/ContributionComment.vue').default);